<template>
  <div class="ml-3">
    <section-title v-if="title" :has-line="true" :title="title" />
    <div
      v-if="!canAdd && value.length == 0 && !disabled"
      class="row bg-secondary-3 rounded p-3 mb-2 d-flex justify-content-center"
      @click="openAttachment"
    >
      <div class="row">
        <div class="col-12 col-md-12 col-sm-6 py-3">
          <label
            class="form-control position-relative text-center mb-0 file-input-container"
          >
            <label class="file-select px-5">
              <em class="fas fa-file-plus pr-2 text-green fa-lg" />
              <span class="font-weight-bold">
                Presione aquí para anejar documento
              </span>
            </label>
          </label>
        </div>
      </div>
    </div>

    <div
      v-if="!canAdd && value.length == 0 && disabled"
      class="d-flex align-items-center justify-content-center py-4 bg-secondary-13 rounded"
    >
      <custom-result-not-found />
    </div>

    <div v-if="canAdd">
      <validation-observer
        ref="documentObserver"
        class="row mr-2 bg-secondary-3 p-3"
        tag="div"
      >
        <div class="col-md-4 col-sm-6">
          <validation-provider v-slot="{ errors }" rules="required">
            <custom-drop-down
              id="ddlDocumentType"
              v-model="documentType"
              custom-error-msg="Favor seleccionar tipo de documento."
              :disabled="disabled"
              :error="errors[0]"
              fieldkey="id"
              fieldname="name"
              label="Tipo de Documento"
              :options="documentTypes"
            />
          </validation-provider>
        </div>
        <div class="col-md-4 col-sm-6">
          <validation-provider v-slot="{ errors }" rules="required">
            <custom-file-input
              ref="fileUpload"
              v-model="file.attachment"
              :accept="file.allowedFiles"
              add-icon="fas fa-file-plus fa-lg"
              custom-error-msg="Favor seleccionar un documento."
              display-style="normal"
              :error="errors[0]"
              label="Documento:"
              label-position="left"
              :on-download="onDownloadFile"
              required
            />
          </validation-provider>
        </div>
        <div class="col-md-4">
          <div class="mt-4 text-right">
            <action-button
              id="btnCancel"
              i="fas fa-times-circle"
              variant="outline-danger btn-cancel danger m-2"
              @click="() => (this.isAdding = !this.isAdding)"
            >
              Cancelar
            </action-button>
            <action-button
              id="btnAdd"
              i="fas fa-file-plus"
              variant="success pl-4 pr-4"
              @click="onAdd"
            >
              Añadir
            </action-button>
          </div>
        </div>
      </validation-observer>
    </div>
    <div v-if="value.length">
      <div
        v-for="(item, index) in value"
        :key="`document-row-${index}`"
        class="row mr-2 bg-secondary-3 p-3 pb-1 mt-3"
      >
        <div class="col-md-4 col-sm-6">
          <span class="font-14 font-weight-normal color-secondary-6">
            Tipo de Documento:
          </span>
          <p class="font-16 font-weight-normal color-black">
            {{ item.documentTypeName || item.documentType.name }}
          </p>
        </div>
        <div class="col-md-4 col-sm-6">
          <span class="font-14 font-weight-normal color-secondary-6">
            Archivo:
          </span>
          <p class="font-16 font-weight-normal color-black">
            {{ item.fileName }}
          </p>
        </div>
        <div class="col-md-4 mt-3 d-none d-md-block d-lg-block text-right">
          <action-button
            id="btn-download-doc"
            i="fas fa-file-download m-icon-0"
            variant="success mx-2"
            @click="onDownloadFile(index)"
          />
          <action-button
            v-if="canRemove"
            id="btn-delete-doc"
            i="fas fa-times-circle m-icon-0"
            variant="danger"
            @click="onRemoveFile(index)"
          />
        </div>
        <div class="col-sm-12 text-center mt-3 d-none d-sm-block d-md-none">
          <action-button
            v-for="(action, indexAction) in getActionItems().filter(
              (f) => f.visible
            )"
            :key="'actions_' + indexAction"
            :variant="'btn btn-md btn-block ' + action.btnColor"
            @click="methodHandle(action.click, index)"
          >
            <i :class="action.iconOutline" />
            {{ action.label }}
          </action-button>
        </div>
      </div>
    </div>
    <div
      v-if="!canAdd && value.length && !disabled"
      class="d-flex justify-content-end mr-2 mt-3"
    >
      <action-button
        v-if="hasAddDocumentPermission"
        id="btnAddEntry"
        i="fas fa-file-plus"
        text="Añadir"
        variant="success pl-4 pr-4"
        @click="openAttachment"
      />
    </div>
  </div>
</template>

<script>
import SectionTitle from 'SectionTitle';
import CustomFileInput from 'CustomFileInput';
import CustomDropDown from 'custom-drop-down';
import CustomResultNotFound from 'custom-result-not-found';
import { ValidationObserver } from 'vee-validate';
import alert from '@/mixins/alert.mixin';

import _generalApi from '@/modules/app/api';
export default {
  components: {
    SectionTitle,
    CustomFileInput,
    CustomDropDown,
    ValidationObserver,
    CustomResultNotFound,
  },
  mixins: [alert],
  props: {
    /* Title of Section by default is Documentos */
    title: {
      type: String,
      default: null,
    },
    /** Documents Types availables for dropdown selection */
    availableDocumentTypes: {
      type: Array,
      default: () => [],
    },
    /** Restrict the documents */
    uniqueDocumentType: {
      type: Boolean,
      default: false,
    },
    //*Alternatives is identify when is slot used
    /* Set Download Documents by Slots */
    viewDocumentsSlot: {
      type: Boolean,
      default: false,
    },
    /** Read Only property for only show list of documents */
    disabled: {
      type: Boolean,
      default: () => false,
    },
    /** value or v-model for files
     *    documentType: KeyValue,
          fileName: String,
          attachment: NUll (Server) || File (Client),
          documentId: String,.*/
    value: {
      type: Array,
      default: () => [],
    },
    /** This property is for auto-upload files when press añadir */
    autoUpload: {
      type: Boolean,
      default: false,
    },
    /** onDownload for componente know how download files */
    onDownload: {
      type: Function,
      required: false,
      default: () => {
        return 'The function onDownload is not implemented';
      },
    },
    canRemove: {
      type: Boolean,
      default: true,
    },
    onRemove: {
      type: Function,
      required: false,
      default: () => {
        return 'The function onRemove is not implemented';
      },
    },
  },
  data() {
    return {
      isAdding: false,
      file: {
        attachment: null,
        allowedFiles: '.pdf',
      },
      documentType: null,
    };
  },
  computed: {
    hasAddDocumentPermission() {
      return this.userHasPermissions('provider.contract.document.add');
    },
    canAdd() {
      return this.isAdding && !this.disabled;
    },
    documentTypes() {
      let documentTypes = [];
      if (this.uniqueDocumentType && this.value.length > 0) {
        let documentTypeIdsAdded = this.value
          .filter((f) => f.documentType.name.toLowerCase() != 'otro')
          .map((d) => {
            return d.documentType.id;
          });
        documentTypes = this.availableDocumentTypes.filter(
          (f) => !documentTypeIdsAdded.includes(f.id)
        );
      } else {
        documentTypes = this.availableDocumentTypes;
      }
      return documentTypes;
    },
  },
  methods: {
    methodHandle(handle, index) {
      handle({ index });
    },
    getActionItems() {
      return [
        {
          name: 'download',
          label: 'Descargar',
          icon: 'fas fa-check-square color-primary-1',
          iconOutline: 'fas fa-check-square',
          btnColor: 'outline-success',
          visible: true,
          click: ({ index }) => {
            this.onDownloadFile(index);
          },
        },
        {
          name: 'remove',
          label: 'Eliminar',
          icon: 'fas fa-times-square color-primary-4',
          iconOutline: 'fas fa-times-square',
          btnColor: 'outline-danger',
          visible: !this.disabled,
          click: ({ index }) => {
            this.onRemoveFile(index);
          },
        },
      ];
    },
    async onAdd() {
      const isValid = await this.$refs.documentObserver.validate();

      if (!isValid) {
        this.$emit('isValid', true);
      }

      let item = {
        documentType: this.documentType,
        fileName: this.file.attachment?.name,
        attachment: this.file.attachment,
        documentId: null, //Identify document server saved.
      };

      if (this.autoUpload) this.onUpload(item);
      else this.value.push(item);

      //Reset Selection
      this.documentType = null;
      this.file.attachment = null;
      //Reset Validations
      this.isAdding = !this.isAdding;
    },
    onUpload(item) {
      this.$emit('onUpload', item);
    },
    openAttachment() {
      this.isAdding = true;
    },
    onDownloadFile(index) {
      //Download File in Memory
      let item = this.value[index];
      if (item.attachment != undefined) {
        _generalApi.downloadFile({
          filename: item.fileName,
          content: item.attachment,
          contentType: item.attachment.type,
        });
      } else {
        //Download File by API
        this.onDownload(item.documentId);
      }
    },
    async onRemoveFile(index) {
      const answer = await this.ShowCancelModal(
        'Atención',
        '¿Está seguro que desea eliminar el documento seleccionado?',
        'Si',
        'No'
      );
      if (answer) {
        let item = this.value[index];
        if (this.onRemove != undefined && item.documentId != undefined) {
          this.$emit('onRemove', item.documentId);
        } else {
          this.value.splice(index, 1);
        }
      }
    },
  },
};
</script>

<style scoped lang="scss">
::v-deep .m-icon-0 {
  margin: 0 !important;
}
</style>
